"use strict";

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Stepper from "react-stepper-horizontal";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Dropdown,
  Row,
  CardGroup,
  CardDeck,
  Card,
} from "react-bootstrap";
import CustomHeader from "../components/Header";

import "../css/Managehssestyle.css";
// import Stepper from 'react-stepper-wizard'
import VehicleGroupBox from "../components/VehicleGroupBox";
import VehicleGroupBoxItem from "../components/VehicleGroupBoxItem";
//import '../css/customBootstrapExtended.css'
import TouchSpin from "../components/TouchSpin";
import VehicleGroupTotalSlider from '../components/VehicleGroupTotalSlider'
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from '../config/axiosConfig'

class Managehsse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        {
          title: "Step One",
          // href: "http://example1.com",
          onClick: (e) => {
            e.preventDefault();
            console.log("onClick", 1);
          },
        },
        {
          title: "Step Two",
          // href: "http://example2.com",
          onClick: (e) => {
            e.preventDefault();
            console.log("onClick", 2);
          },
        },
      ],
      currentStep: 0,
      msgSpeeding: 0,
      msgHA: 0,
      msgHB: 0,
      msgHC: 0,
      msgHT: 0,
      msgHCor: 0,
      msgSBV: 0,
      TotalPercentage: 0,
      HsseEvents: []

    }



    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrevious = this.onClickPrevious.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this)
    // this.currentPage = this.currentPage.bind(this)
    
  }

  async componentDidMount() {
    
    axiosConfig.post("Portal/GetHSSEScore",
    {
      UserBranchID: this.props.data.selectedBranchId,
      Events: this.state.HsseEvents
    }
  )
    .then(Response => {

      
      console.log(Response.data.hsseScore)
      for (var i = 0; i < Response.data.hsseScore.length; i++) {
        console.log(i)

        if (Response.data.hsseScore[i].event === "OVER_SPEEDING") {
          console.log('OverSpeeding Data: ' + Response.data.hsseScore[i].score)
          this.setState({
            msgSpeeding: Response.data.hsseScore[i].score
          })
        }

        if (Response.data.hsseScore[i].event === "HARSH_ACCELERATION") {
           this.setState({
            msgHA: Response.data.hsseScore[i].score
          })
        }

        if (Response.data.hsseScore[i].event === "HARSH_BRAKING") {
           this.setState({
            msgHB: Response.data.hsseScore[i].score
          })
        }

        if (Response.data.hsseScore[i].event === "HARSH_TURN") {
           this.setState({
            msgHT: Response.data.hsseScore[i].score
          })
        }

        if (Response.data.hsseScore[i].event === "IDLING_TIME") {
           this.setState({
            msgHC: Response.data.hsseScore[i].score
          })
        }
        if (Response.data.hsseScore[i].event === "SEAT_BELT_VIOLATION") {
           this.setState({
            msgSBV: Response.data.hsseScore[i].score
          })
        }
      }
       this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgSpeeding + this.state.msgHA + this.state.msgHB + this.state.msgHC + this.state.msgSBV + this.state.msgHT) })

    })
    .catch(error => {
      Swal.fire({
        title: error.response.data.errorMessage,
        text: 'Some Error !',
        icon: 'error',
        confirmButtonText: 'Okay'
      })
    })
  }

  

  callbackFunction_Speeding = (childData) => {

    var temp = this.state.msgSpeeding;
    this.setState({ msgSpeeding: childData })
    this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgSpeeding) - temp })
  }

  callbackFunction_HA = (childData) => {

    var temp = this.state.msgHA;
    this.setState({ msgHA: childData })
    this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgHA) - temp })
  }

  callbackFunction_HB = (childData) => {

    var temp = this.state.msgHB;
    this.setState({ msgHB: childData })
    this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgHB) - temp })
  }
  callbackFunction_HC = (childData) => {

    var temp = this.state.msgHC;
    this.setState({ msgHC: childData })
    this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgHC) - temp })
  }

  callbackFunction_HCor = (childData) => {

    var temp = this.state.msgHCor;
    this.setState({ msgHCor: childData })
    this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgHCor) - temp })
    console.log("this.TotalPercentage " + this.state.TotalPercentage);
  }


  callbackFunction_HT = (childData) => {

    var temp = this.state.msgHT;
    this.setState({ msgHT: childData })
    this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgHT) - temp })
    console.log("this.TotalPercentage " + this.state.TotalPercentage);
  }

  callbackFunction_SBV = (childData) => {

    var temp = this.state.msgSBV;
    this.setState({ msgSBV: childData })
    this.setState({ TotalPercentage: (this.state.TotalPercentage + this.state.msgSBV) - temp })
    console.log("this.TotalPercentage " + this.state.TotalPercentage);
  }




  async handleSubmit() {

    let token = localStorage.getItem('token');
    let Events = []

    let hsse = {
      Event: "OVER_SPEEDING",
      Value: this.state.msgSpeeding
    }
    Events.push(hsse);

    hsse = {
      Event: "HARSH_ACCELERATION",
      Value: this.state.msgHA
    }
    Events.push(hsse);

    hsse = {
      Event: "HARSH_BRAKING",
      Value: this.state.msgHB
    }
    Events.push(hsse);

    hsse = {
      Event: "IDLING_TIME",
      Value: this.state.msgHC
    }
    Events.push(hsse);

    hsse = {
      Event: "SEAT_BELT_VIOLATION",
      Value: this.state.msgSBV
    }
    Events.push(hsse);

    hsse = {
      Event: "HARSH_TURN",
      Value: this.state.msgHT
    }
    Events.push(hsse);

    await this.setState(
      {
        HsseEvents: Events
      })

    axiosConfig.post("Portal/HSSEScore",
      {
        UserBranchID: this.props.data.selectedBranchId,
        Events: this.state.HsseEvents
      })
      .then(Response => {
        Swal.fire({
          icon: 'success',
          title: 'Updated Successfully',
        })
      })
      .catch(error => {
        Swal.fire({
          title: error.response.data.errorMessage,
          text: 'Some Error !',
          icon: 'error',
          confirmButtonText: 'Okay'
        })
      })
    /*End*/


  }


  onClickNext() {
    console.log(this.state.currentStep);
    if (this.state.currentStep < 1)
      this.setState({
        currentStep: this.state.currentStep + 1,
      });
  }

  onClickPrevious() {
    console.log(this.state.currentStep);
    if (this.state.currentStep == 1)
      this.setState({
        currentStep: this.state.currentStep - 1,
      });
  }





  render() {
    const { steps, currentStep } = this.state;
    const buttonStyle = {
      background: "#E0E0E0",
      width: 200,
      padding: 16,
      textAlign: "center",
      margin: "0 auto",
      marginTop: 32,
    };

    return (
      <>
        {/* <CustomHeader /> */}
        <Container>
          <CardDeck className="text-left">
            <Card>
              <Card.Title className="px-3 mt-3">
                <h4> Manage Safety Events </h4>
              </Card.Title>
              <Card.Body>
                {/* <Stepper
                  steps={steps}
                  activeStep={currentStep}
                  activeColor="#ffd500"
                  defaultBarColor="#ffd500"
                  completeColor="red"
                  completeBarColor="#ffd500"
                  defaultBorderColor="green"
                />
                {currentStep === 0 && (

                  <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>

                    <div className="col-sm-12 col-12">
                      <Row>
                        <GroupVRNSelect></GroupVRNSelect>
                      </Row>

                    </div>

                  </div>
                )} */}
                  {/* 
                {currentStep === 1 && ( */}
                  <>
                    <fieldset>
                      <div className="row">
                        <div className="col-sm-12">
                          <h5 className="mb-1">
                            Driver Safety Performance Score 
                          </h5>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <p>
                           Update the points to be deducted from each Driver's score for each category of safety violation
                          </p>
                        </div>
                      </div>


                      <CardDeck>
                        <div className="row match-height align-items-center">
                          <TouchSpin
                            parentCallback={this.callbackFunction_Speeding}
                            elementvalue={this.state.msgSpeeding}
                            Title="Overspeeding"
                            Totalpercentage={this.state.TotalPercentage}
                          >
                          </TouchSpin>
                          <TouchSpin
                            parentCallback={this.callbackFunction_HA}
                            elementvalue={this.state.msgHA}
                            Title="Harsh Acceleration"
                            Totalpercentage={this.state.TotalPercentage}
                          >
                            {" "}
                          </TouchSpin>
                          <TouchSpin
                            parentCallback={this.callbackFunction_HB}
                            elementvalue={this.state.msgHB}
                            Title="Harsh Braking"
                            Totalpercentage={this.state.TotalPercentage}
                          >
                            {" "}
                          </TouchSpin>
                          <TouchSpin
                            parentCallback={this.callbackFunction_HT}
                            elementvalue={this.state.msgHT}
                            Title="Harsh Turn"
                            Totalpercentage={this.state.TotalPercentage}
                          >
                            {" "}
                          </TouchSpin>
                          <TouchSpin
                            parentCallback={this.callbackFunction_HC}
                            elementvalue={this.state.msgHC}
                            Title="Idling Time"
                            Totalpercentage={this.state.TotalPercentage}
                          >
                            {" "}
                          </TouchSpin>
                          <TouchSpin
                            parentCallback={this.callbackFunction_SBV}
                            elementvalue={this.state.msgSBV}
                            Title="Seat Belt Violation"
                            Totalpercentage={this.state.TotalPercentage}
                          >
                            {" "}
                          </TouchSpin>
                          {/* <VehicleGroupTotalSlider Totalpercentage={this.state.TotalPercentage} /> */}


                        </div>
                      </CardDeck>
                      <div className='d-flex justify-content-center'>
                        <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.handleSubmit}>SAVE</button>
                      </div>

                    </fieldset>
                  </>
                {/* )} */}

                {/* <div>
                  {this.state.currentStep == 1 &&
                    <div class="pull-left">
                      <Button
                        className="btn-shell"
                        variant="warning"
                        onClick={this.onClickPrevious}
                      >
                        Previous
                    </Button>
                    </div>
                  }
                  {this.state.currentStep == 0 &&
                    <div class="pull-right">

                      <Button className="btn-shell" variant="warning" onClick={this.onClickNext}>
                        Next
                    </Button>
                    </div>
                  }
                </div> */}
              </Card.Body>
            </Card>
          </CardDeck>
        </Container>
      </>
    );
  }
}

export default Managehsse;
